import { css } from "styled-components";

export const actionHoverTransition = css`
  transform: translateX(0.5rem);
`;
